module.exports = __webpack_public_path__ + "img/bottle_refill_2.829dcc4d.jpg";